<template>
  <table
    class="st-Background shadow"
    bgcolor="#F0F2F8"
    border="0"
    cellpadding="0"
    cellspacing="0"
    width="100%"
    style="border: 0; margin: 0; padding: 0; text-align: left"
  >
    <tbody>
      <tr>
        <td style="font-size: 16px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
        <td>
          <!-- Wrapper -->
          <table
            class="st-Wrapper"
            align="center"
            border="0"
            cellpadding="0"
            cellspacing="0"
            style="width: 440px; min-width: 440px; max-width: 440px"
          >
            <tbody>
              <tr>
                <td>
                  <table
                    class="st-Preheader st-Width st-Width--mobile"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="440"
                    style="min-width: 440px"
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          height="0"
                          style="
                            border: 0;
                            margin: 0;
                            padding: 0;
                            color: #ffffff;
                            display: none !important;
                            font-size: 1px;
                            line-height: 1px;
                            max-height: 0;
                            max-width: 0;
                            mso-hide: all !important;
                            opacity: 0;
                            overflow: hidden;
                            visibility: hidden;
                          "
                        >
                          <span
                            v-if="user.currentUser !== null"
                            class="st-Delink st-Delink--preheader"
                            style="color: #ffffff; text-decoration: none"
                          >
                            New invoice from
                            {{ user.currentUser.Organization.OrganizationName }}

                            #EXAMPLE-0001

                            <!-- Prevents elements showing up in email client preheader text -->
                            ‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;
                            <!-- /Prevents elements showing up in email client preheader text -->
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                  >
                    <tbody>
                      <tr>
                        <td
                          height="58"
                          style="
                            border: 0;
                            margin: 0;
                            padding: 0;
                            font-size: 1px;
                            line-height: 1px;
                            max-height: 1px;
                            mso-line-height-rule: exactly;
                          "
                        >
                          <div class="st-Spacer st-Spacer--filler">&nbsp;</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table cellpadding="0" cellspacing="0" style="width: 100%">
                    <tbody>
                      <tr>
                        <td
                          align=""
                          style="
                            border: 0;
                            border-collapse: collapse;
                            margin: 0;
                            padding: 0;

                            width: 100%;
                            width: 482px;
                            border-radius: 12px;
                            box-shadow: 0 2px 5px 0 rgb(50 50 93 / 10%),
                              0 1px 1px 0 rgb(0 0 0 / 7%);
                          "
                        >
                          <table
                            cellpadding="0"
                            cellspacing="0"
                            style="width: 100%"
                          >
                            <tbody>
                              <tr>
                                <td
                                  align=""
                                  style="
                                    border: 0;
                                    border-collapse: collapse;
                                    margin: 0;
                                    padding: 0;

                                    width: 100%;
                                    width: 482px;
                                    border-radius: 12px;
                                    background-color: #e3e8ee;
                                    padding: 1px;
                                  "
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    style="
                                      width: 100%;
                                      background-color: #ffffff;
                                      border-radius: 12px;
                                    "
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          style="
                                            border: 0;
                                            border-collapse: collapse;
                                            margin: 0;
                                            padding: 0;
                                          "
                                        >
                                          <table
                                            class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                            border="0"
                                            cellpadding="0"
                                            cellspacing="0"
                                            width="100%"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  height="32"
                                                  style="
                                                    border: 0;
                                                    margin: 0;
                                                    padding: 0;
                                                    font-size: 1px;
                                                    line-height: 1px;
                                                    max-height: 1px;
                                                    mso-line-height-rule: exactly;
                                                  "
                                                >
                                                  <div
                                                    class="st-Spacer st-Spacer--filler"
                                                  >
                                                    &nbsp;
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>

                                          <table
                                            cellpadding="0"
                                            cellspacing="0"
                                            style="width: 100%"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  style="
                                                    border: 0;
                                                    border-collapse: collapse;
                                                    margin: 0;
                                                    padding: 0;

                                                    min-width: 32px;
                                                    width: 32px;
                                                    font-size: 1px;
                                                  "
                                                >
                                                  &nbsp;
                                                </td>

                                                <td
                                                  style="
                                                    border: 0;
                                                    border-collapse: collapse;
                                                    margin: 0;
                                                    padding: 0;
                                                  "
                                                >
                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            width: 100%;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                    padding-bottom: 2px;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #7a7a7a;
                                                                      font-size: 14px;
                                                                      line-height: 20px;

                                                                      font-weight: 500;
                                                                    "
                                                                  >
                                                                    Invoice from
                                                                    <span
                                                                      v-if="
                                                                        user.currentUser !==
                                                                        null
                                                                      "
                                                                    >
                                                                      {{
                                                                        user
                                                                          .currentUser
                                                                          .Organization
                                                                          .OrganizationName
                                                                      }}
                                                                    </span>
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>

                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                    padding-bottom: 2px;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 28px;
                                                                      line-height: 40px;

                                                                      font-weight: 600;
                                                                    "
                                                                  >
                                                                    ${{
                                                                      amountDue?.toFixed(
                                                                        2
                                                                      )
                                                                    }}
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>

                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #7a7a7a;
                                                                      font-size: 14px;
                                                                      line-height: 24px;

                                                                      font-weight: 500;
                                                                    "
                                                                  >
                                                                    {{
                                                                      // new Date(
                                                                      //   dueDate
                                                                      // ).toLocaleDateString(
                                                                      //   "en-us",
                                                                      //   {
                                                                      //     weekday:
                                                                      //       "long",
                                                                      //     year: "numeric",
                                                                      //     month:
                                                                      //       "short",
                                                                      //     day: "numeric",
                                                                      //   }
                                                                      // )
                                                                      sendDate
                                                                    }}
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>

                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  colspan="1"
                                                                  height="16"
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    height: 16px;

                                                                    font-size: 1px;

                                                                    line-height: 1px;

                                                                    mso-line-height-rule: exactly;
                                                                  "
                                                                >
                                                                  &nbsp;
                                                                </td>
                                                              </tr>

                                                              <tr>
                                                                <td
                                                                  height="1"
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    height: 1px;

                                                                    font-size: 1px;
                                                                    background-color: #ebebeb;
                                                                    line-height: 1px;
                                                                  "
                                                                >
                                                                  &nbsp;
                                                                </td>
                                                              </tr>

                                                              <tr>
                                                                <td
                                                                  colspan="1"
                                                                  height="12"
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    height: 12px;

                                                                    font-size: 1px;

                                                                    line-height: 1px;

                                                                    mso-line-height-rule: exactly;
                                                                  "
                                                                >
                                                                  &nbsp;
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            width: 76px;
                                                            max-width: 76px;
                                                          "
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            class="h-12 w-12 text-gray-300 group-hover:text-gray-400"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                          >
                                                            <path
                                                              stroke-linecap="round"
                                                              stroke-linejoin="round"
                                                              stroke-width="2"
                                                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                            />
                                                          </svg>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          align=""
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            width: 100%;
                                                          "
                                                        >
                                                          <a
                                                            style="
                                                              border: 0;
                                                              margin: 0;
                                                              padding: 0;
                                                              text-decoration: none;
                                                              outline: 0;
                                                              display: flex;
                                                            "
                                                            href="https://dashboard.stripe.com"
                                                          >
                                                            <img
                                                              src="https://stripe-images.s3.amazonaws.com/emails/invoices_arrow_down.png"
                                                              height="12"
                                                              width="12"
                                                              style="
                                                                border: 0;
                                                                line-height: 100%;
                                                                margin-right: 4px;
                                                                position: relative;
                                                                top: 1px;
                                                              "
                                                            />
                                                            <span
                                                              style="
                                                                font-family: -apple-system,
                                                                  BlinkMacSystemFont,
                                                                  'Segoe UI',
                                                                  Roboto,
                                                                  'Helvetica Neue',
                                                                  Ubuntu,
                                                                  sans-serif;
                                                                text-decoration: none;

                                                                color: #7a7a7a;
                                                                font-size: 14px;
                                                                line-height: 16px;

                                                                font-weight: 500;
                                                              "
                                                            >
                                                              Download invoice
                                                            </span>
                                                          </a>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                                    border="0"
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    width="100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height="32"
                                                          style="
                                                            border: 0;
                                                            margin: 0;
                                                            padding: 0;
                                                            font-size: 1px;
                                                            line-height: 1px;
                                                            max-height: 1px;
                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          <div
                                                            class="st-Spacer st-Spacer--filler"
                                                          >
                                                            &nbsp;
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style=""
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            vertical-align: top;

                                                            white-space: nowrap;
                                                          "
                                                        >
                                                          <span
                                                            style="
                                                              font-family: -apple-system,
                                                                BlinkMacSystemFont,
                                                                'Segoe UI',
                                                                Roboto,
                                                                'Helvetica Neue',
                                                                Ubuntu,
                                                                sans-serif;
                                                              text-decoration: none;

                                                              color: #7a7a7a;
                                                              font-size: 14px;
                                                              line-height: 16px;
                                                            "
                                                          >
                                                            To
                                                          </span>
                                                        </td>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            width: 24px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;
                                                          "
                                                        >
                                                          <span
                                                            style="
                                                              font-family: -apple-system,
                                                                BlinkMacSystemFont,
                                                                'Segoe UI',
                                                                Roboto,
                                                                'Helvetica Neue',
                                                                Ubuntu,
                                                                sans-serif;
                                                              text-decoration: none;

                                                              color: #1a1a1a;
                                                              font-size: 14px;
                                                              line-height: 16px;
                                                            "
                                                          >
                                                            {{ customer.name }}
                                                          </span>
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          colspan="2"
                                                          height="8"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 8px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            vertical-align: top;

                                                            white-space: nowrap;
                                                          "
                                                        >
                                                          <span
                                                            style="
                                                              font-family: -apple-system,
                                                                BlinkMacSystemFont,
                                                                'Segoe UI',
                                                                Roboto,
                                                                'Helvetica Neue',
                                                                Ubuntu,
                                                                sans-serif;
                                                              text-decoration: none;

                                                              color: #7a7a7a;
                                                              font-size: 14px;
                                                              line-height: 16px;
                                                            "
                                                          >
                                                            From
                                                          </span>
                                                        </td>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            width: 24px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;
                                                          "
                                                        >
                                                          <span
                                                            style="
                                                              font-family: -apple-system,
                                                                BlinkMacSystemFont,
                                                                'Segoe UI',
                                                                Roboto,
                                                                'Helvetica Neue',
                                                                Ubuntu,
                                                                sans-serif;
                                                              text-decoration: none;

                                                              color: #1a1a1a;
                                                              font-size: 14px;
                                                              line-height: 16px;
                                                            "
                                                          >
                                                            <span
                                                              v-if="
                                                                user.currentUser !==
                                                                null
                                                              "
                                                            >
                                                              {{
                                                                user.currentUser
                                                                  .Organization
                                                                  .OrganizationName
                                                              }}</span
                                                            >
                                                          </span>
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          colspan="2"
                                                          height="8"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 8px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            vertical-align: top;

                                                            white-space: nowrap;
                                                          "
                                                        >
                                                          <span
                                                            style="
                                                              font-family: -apple-system,
                                                                BlinkMacSystemFont,
                                                                'Segoe UI',
                                                                Roboto,
                                                                'Helvetica Neue',
                                                                Ubuntu,
                                                                sans-serif;
                                                              text-decoration: none;

                                                              color: #7a7a7a;
                                                              font-size: 14px;
                                                              line-height: 16px;
                                                            "
                                                          >
                                                            Memo
                                                          </span>
                                                        </td>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            width: 24px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;
                                                          "
                                                        >
                                                          <span
                                                            style="
                                                              font-family: -apple-system,
                                                                BlinkMacSystemFont,
                                                                'Segoe UI',
                                                                Roboto,
                                                                'Helvetica Neue',
                                                                Ubuntu,
                                                                sans-serif;
                                                              text-decoration: none;

                                                              color: #1a1a1a;
                                                              font-size: 14px;
                                                              line-height: 16px;
                                                            "
                                                          >
                                                            {{ memo }}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                                    border="0"
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    width="100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height="24"
                                                          style="
                                                            border: 0;
                                                            margin: 0;
                                                            padding: 0;
                                                            font-size: 1px;
                                                            line-height: 1px;
                                                            max-height: 1px;
                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          <div
                                                            class="st-Spacer st-Spacer--filler"
                                                          >
                                                            &nbsp;
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>

                                                <td
                                                  style="
                                                    border: 0;
                                                    border-collapse: collapse;
                                                    margin: 0;
                                                    padding: 0;

                                                    min-width: 32px;
                                                    width: 32px;
                                                    font-size: 1px;
                                                  "
                                                >
                                                  &nbsp;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>

                                          <table
                                            class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                            border="0"
                                            cellpadding="0"
                                            cellspacing="0"
                                            width="100%"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  height="24"
                                                  style="
                                                    border: 0;
                                                    margin: 0;
                                                    padding: 0;
                                                    font-size: 1px;
                                                    line-height: 1px;
                                                    max-height: 1px;
                                                    mso-line-height-rule: exactly;
                                                  "
                                                >
                                                  <div
                                                    class="st-Spacer st-Spacer--filler"
                                                  >
                                                    &nbsp;
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                  >
                    <tbody>
                      <tr>
                        <td
                          height="20"
                          style="
                            border: 0;
                            margin: 0;
                            padding: 0;
                            font-size: 1px;
                            line-height: 1px;
                            max-height: 1px;
                            mso-line-height-rule: exactly;
                          "
                        >
                          <div class="st-Spacer st-Spacer--filler">&nbsp;</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table cellpadding="0" cellspacing="0" style="width: 100%">
                    <tbody>
                      <tr>
                        <td
                          align=""
                          style="
                            border: 0;
                            border-collapse: collapse;
                            margin: 0;
                            padding: 0;

                            width: 100%;
                            width: 482px;
                            border-radius: 12px;
                            box-shadow: 0 2px 5px 0 rgb(50 50 93 / 10%),
                              0 1px 1px 0 rgb(0 0 0 / 7%);
                          "
                        >
                          <table
                            cellpadding="0"
                            cellspacing="0"
                            style="width: 100%"
                          >
                            <tbody>
                              <tr>
                                <td
                                  align=""
                                  style="
                                    border: 0;
                                    border-collapse: collapse;
                                    margin: 0;
                                    padding: 0;

                                    width: 100%;
                                    width: 482px;
                                    border-radius: 12px;
                                    background-color: #e3e8ee;
                                    padding: 1px;
                                  "
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    style="
                                      width: 100%;
                                      background-color: #ffffff;
                                      border-radius: 12px;
                                    "
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          style="
                                            border: 0;
                                            border-collapse: collapse;
                                            margin: 0;
                                            padding: 0;
                                          "
                                        >
                                          <table
                                            class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                            border="0"
                                            cellpadding="0"
                                            cellspacing="0"
                                            width="100%"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  height="32"
                                                  style="
                                                    border: 0;
                                                    margin: 0;
                                                    padding: 0;
                                                    font-size: 1px;
                                                    line-height: 1px;
                                                    max-height: 1px;
                                                    mso-line-height-rule: exactly;
                                                  "
                                                >
                                                  <div
                                                    class="st-Spacer st-Spacer--filler"
                                                  >
                                                    &nbsp;
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>

                                          <table
                                            cellpadding="0"
                                            cellspacing="0"
                                            style="width: 100%"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  style="
                                                    border: 0;
                                                    border-collapse: collapse;
                                                    margin: 0;
                                                    padding: 0;
                                                  "
                                                >
                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;
                                                          "
                                                        >
                                                          <span
                                                            style="
                                                              font-family: -apple-system,
                                                                BlinkMacSystemFont,
                                                                'Segoe UI',
                                                                Roboto,
                                                                'Helvetica Neue',
                                                                Ubuntu,
                                                                sans-serif;
                                                              text-decoration: none;

                                                              color: #7a7a7a;
                                                              font-size: 14px;
                                                              line-height: 20px;

                                                              font-weight: 500;
                                                            "
                                                          >
                                                            Invoice
                                                            #EXAMPLE-0001
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                                    border="0"
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    width="100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height="26"
                                                          style="
                                                            border: 0;
                                                            margin: 0;
                                                            padding: 0;
                                                            font-size: 1px;
                                                            line-height: 1px;
                                                            max-height: 1px;
                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          <div
                                                            class="st-Spacer st-Spacer--filler"
                                                          >
                                                            &nbsp;
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          colspan="3"
                                                          height="16"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 16px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          height="1"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 1px;

                                                            font-size: 1px;
                                                            background-color: #ebebeb;
                                                            line-height: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          colspan="3"
                                                          height="16"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 16px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                    v-for="(
                                                      item, index
                                                    ) in items.value"
                                                    :key="index"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            padding-left: 0px;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 14px;
                                                                      line-height: 16px;

                                                                      font-weight: 500;

                                                                      word-break: break-word;
                                                                    "
                                                                  >
                                                                    {{
                                                                      item.Name
                                                                    }}
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>

                                                          <table
                                                            class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                                            border="0"
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            width="100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  height="3"
                                                                  style="
                                                                    border: 0;
                                                                    margin: 0;
                                                                    padding: 0;
                                                                    font-size: 1px;
                                                                    line-height: 1px;
                                                                    max-height: 1px;
                                                                    mso-line-height-rule: exactly;
                                                                  "
                                                                >
                                                                  <div
                                                                    class="st-Spacer st-Spacer--filler"
                                                                  >
                                                                    &nbsp;
                                                                  </div>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #999999;
                                                                      font-size: 12px;
                                                                      line-height: 14px;
                                                                    "
                                                                  >
                                                                    Qty
                                                                    {{
                                                                      item.Quantity
                                                                    }}
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 16px;
                                                            width: 16px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          align="right"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            text-align: right;
                                                            vertical-align: top;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align="right"
                                                                  nowrap=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 14px;
                                                                      line-height: 16px;

                                                                      font-weight: 500;

                                                                      white-space: nowrap;
                                                                    "
                                                                  >
                                                                    ${{
                                                                      item.Price?.toFixed(
                                                                        2
                                                                      )
                                                                    }}
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          colspan="5"
                                                          height="24"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 24px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <div
                                                    v-if="taxRates.length > 0"
                                                    class="devider"
                                                  ></div>

                                                  <!-- Tax Rates -->
                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                    v-for="(
                                                      item, index
                                                    ) in taxRates"
                                                    :key="index"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            padding-left: 0px;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 14px;
                                                                      line-height: 16px;

                                                                      font-weight: 500;

                                                                      word-break: break-word;
                                                                    "
                                                                  >
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>

                                                          <table
                                                            class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                                            border="0"
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            width="100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  height="3"
                                                                  style="
                                                                    border: 0;
                                                                    margin: 0;
                                                                    padding: 0;
                                                                    font-size: 1px;
                                                                    line-height: 1px;
                                                                    max-height: 1px;
                                                                    mso-line-height-rule: exactly;
                                                                  "
                                                                >
                                                                  <div
                                                                    class="st-Spacer st-Spacer--filler"
                                                                  >
                                                                    &nbsp;
                                                                  </div>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #999999;
                                                                      font-size: 12px;
                                                                      line-height: 14px;
                                                                    "
                                                                  >
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 16px;
                                                            width: 16px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          align="right"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            text-align: right;
                                                            vertical-align: top;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align="right"
                                                                  nowrap=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 14px;
                                                                      line-height: 16px;

                                                                      font-weight: 500;

                                                                      white-space: nowrap;
                                                                    "
                                                                  >
                                                                    {{
                                                                      item.display_name
                                                                    }}
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          colspan="5"
                                                          height="24"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 24px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                  <!-- End Tax Rates -->

                                                  <!-- Amount Paid  -->
                                                  <table
                                                    v-if="amountPaid > 0"
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            padding-left: 0px;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 14px;
                                                                      line-height: 16px;

                                                                      font-weight: 500;

                                                                      word-break: break-word;
                                                                    "
                                                                  >
                                                                    Amount paid
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 16px;
                                                            width: 16px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          align="right"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            text-align: right;
                                                            vertical-align: top;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align="right"
                                                                  nowrap=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 14px;
                                                                      line-height: 16px;

                                                                      font-weight: 500;

                                                                      white-space: nowrap;
                                                                    "
                                                                  >
                                                                    ${{
                                                                      amountPaid
                                                                    }}
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          colspan="5"
                                                          height="0"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 0px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            padding-left: 0px;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 14px;
                                                                      line-height: 16px;

                                                                      font-weight: 500;

                                                                      word-break: break-word;
                                                                    "
                                                                  >
                                                                    Amount due
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 16px;
                                                            width: 16px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          align="right"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            text-align: right;
                                                            vertical-align: top;
                                                          "
                                                        >
                                                          <table
                                                            cellpadding="0"
                                                            cellspacing="0"
                                                            style="width: 100%"
                                                          >
                                                            <tbody>
                                                              <tr>
                                                                <td
                                                                  align="right"
                                                                  nowrap=""
                                                                  style="
                                                                    border: 0;
                                                                    border-collapse: collapse;
                                                                    margin: 0;
                                                                    padding: 0;

                                                                    width: 100%;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="
                                                                      font-family: -apple-system,
                                                                        BlinkMacSystemFont,
                                                                        'Segoe UI',
                                                                        Roboto,
                                                                        'Helvetica Neue',
                                                                        Ubuntu,
                                                                        sans-serif;
                                                                      text-decoration: none;

                                                                      color: #1a1a1a;
                                                                      font-size: 14px;
                                                                      line-height: 16px;

                                                                      font-weight: 500;

                                                                      white-space: nowrap;
                                                                    "
                                                                  >
                                                                    ${{
                                                                      amountDue?.toFixed(
                                                                        2
                                                                      )
                                                                    }}
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          colspan="5"
                                                          height="0"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 0px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>

                                                  <table
                                                    cellpadding="0"
                                                    cellspacing="0"
                                                    style="width: 100%"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          colspan="3"
                                                          height="16"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 16px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          height="1"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 1px;

                                                            font-size: 1px;
                                                            background-color: #ebebeb;
                                                            line-height: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>

                                                        <td
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            min-width: 32px;
                                                            width: 32px;
                                                            font-size: 1px;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td
                                                          colspan="3"
                                                          height="20"
                                                          style="
                                                            border: 0;
                                                            border-collapse: collapse;
                                                            margin: 0;
                                                            padding: 0;

                                                            height: 20px;

                                                            font-size: 1px;

                                                            line-height: 1px;

                                                            mso-line-height-rule: exactly;
                                                          "
                                                        >
                                                          &nbsp;
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>

                                          <table
                                            class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                                            border="0"
                                            cellpadding="0"
                                            cellspacing="0"
                                            width="100%"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  height="24"
                                                  style="
                                                    border: 0;
                                                    margin: 0;
                                                    padding: 0;
                                                    font-size: 1px;
                                                    line-height: 1px;
                                                    max-height: 1px;
                                                    mso-line-height-rule: exactly;
                                                  "
                                                >
                                                  <div
                                                    class="st-Spacer st-Spacer--filler"
                                                  >
                                                    &nbsp;
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    class="st-Spacer st-Spacer--standalone st-Width st-Width--mobile"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                  >
                    <tbody>
                      <tr>
                        <td
                          height="32"
                          style="
                            border: 0;
                            margin: 0;
                            padding: 0;
                            font-size: 1px;
                            line-height: 1px;
                            max-height: 1px;
                            mso-line-height-rule: exactly;
                          "
                        >
                          <div class="st-Spacer st-Spacer--filler">&nbsp;</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="font-size: 16px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
      </tr>
      <tr>
        <td
          class="st-Spacer st-Spacer--emailEnd"
          height="64"
          colspan="3"
          style="
            border: 0;
            margin: 0;
            padding: 0;
            font-size: 1px;
            line-height: 1px;
            mso-line-height-rule: exactly;
          "
        >
          <div class="st-Spacer st-Spacer--filler">&nbsp;</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    memo: {
      type: String,
      required: true,
    },
    dueDate: {
      type: String,
      required: true,
    },
    customDate: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      required: true,
    },
    customer: {
      type: Object,
      required: true,
    },
    taxRates: {
      type: Array,
      required: true,
    },
    amountPaid: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const user = computed(() => store.state.user);

    const formattedDate = (date) => {
      return new Date(date).toLocaleDateString("en-us", {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    };

    const sendDate = computed(() => {
      if (props.customDate) return formattedDate(props.customDate);

      return formattedDate(props.dueDate);
    });

    const total = computed(() => {
      if (props.items.value === undefined) return 0;

      return (
        props.items.value.reduce((acc, item) => {
          return acc + item.Price * item.Quantity;
        }, 0) - props.amountPaid
      );
    });

    const amountDue = computed(() => {
      if (props.taxRates === undefined) return 0;

      const taxRateTotal = props.taxRates.reduce((acc, taxRate) => {
        return acc + taxRate.percentage;
      }, 0);

      return total.value * (1 + taxRateTotal / 100);
    });

    return {
      store,
      total,
      user,
      amountDue,
      sendDate,
    };
  },
};
</script>

<style scoped>
table.st-Background {
  background-color: rgb(240, 242, 248);
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  -webkit-border-horizontal-spacing: 0px;
  -webkit-border-vertical-spacing: 0px;
  width: 100%;
}

.st-Wrapper {
  margin: 0 auto;
  min-width: 480px;
  width: 480px;
}

table.st-Preheader.st-Width.st-Width--mobile {
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  -webkit-border-horizontal-spacing: 0px;
  -webkit-border-vertical-spacing: 0px;
  width: 440px;
}

table.st-Spacer.st-Spacer--standalone.st-Width.st-Width--mobile {
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  -webkit-border-horizontal-spacing: 0px;
  -webkit-border-vertical-spacing: 0px;
  width: 100%;
}

.devider {
  border: 0px none;
  border-collapse: collapse;
  margin: 0px;
  padding: 0px;
  height: 1px;
  font-size: 1px;
  background-color: rgb(235, 235, 235);
  line-height: 1px;
  margin: 0px 30px;
  margin-bottom: 24px;
}
</style>
